import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';

import App from './App';
import MuiPickersUtilsProvider from 'material-ui-pickers/MuiPickersUtilsProvider';
import MomentUtils from 'material-ui-pickers/utils/moment-utils';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core';


import configureStore from './store/configureStore';
import registerServiceWorker from './registerServiceWorker';
import 'typeface-roboto';
import './assets/css/style.css'

const store = configureStore();

const materialTheme = createMuiTheme({
    overrides: {
        MuiPickersToolbar: {
            toolbar: {
                backgroundColor: '#dd1d21',
                textTransform: 'uppercase',
                color: 'white',
            },
        },
        MuiPickersCalendarHeader: {
            switchHeader: {
                textTransform: 'uppercase'
            },
            daysHeader: {
                textTransform: 'uppercase',
                fontSize: 14
            },
        },
        MuiPickersYear: {
            selected: {
                color: '#dd1d21'
            }
        },
        MuiPickersDay: {
            day: {
                fontSize: 14,
                lineHeight: '14px'
            },
            selected: {
                backgroundColor: '#dd1d21',
                color: 'white',
                '&:hover':{
                    backgroundColor: '#AE0E12',
                }
            },
            current: {
                color: '#dd1d21',
            },
        },
        MuiPickersModal: {
            dialogAction: {
                color: '#dd1d21',
                fontSize: 14
            },
        },
    },
});

ReactDOM.render(
    <Provider store={store}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
            <MuiThemeProvider theme={materialTheme}>
            <App/>
            </MuiThemeProvider>
        </MuiPickersUtilsProvider>
    </Provider>,
    document.querySelector('#root')
);
registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js